import React from 'react';
interface MondrianPanelProps {
  children: React.ReactNode;
  borderWidth?: 4 | 8;
  className?: string;
  noPadding?: boolean;
}
export function MondrianPanel({
  children,
  borderWidth = 4,
  className = '',
  noPadding = false
}: MondrianPanelProps) {
  const borderClass = borderWidth === 8 ? 'border-8' : 'border-4';
  return <div className={`
      bg-mondrian-white 
      border-mondrian-black 
      ${borderClass}
      sharp-corners
      ${noPadding ? '' : 'p-6'}
      ${className}
    `} data-id="element-246">
      {children}
    </div>;
}